import { render, staticRenderFns } from "./_linkReferrerModal.vue?vue&type=template&id=4f019ca0"
import script from "./_linkReferrerModal.vue?vue&type=script&lang=js"
export * from "./_linkReferrerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports